import { resolveMarketingBaseUrl } from "@/lib/blog/frame";

/**
 * Admin environment configuration.
 *
 * VITE_API_URL — base URL of the ATSReady API (e.g. https://api.atsready.ai).
 * Falls back to '/api' for local dev proxied through Vite.
 *
 * VITE_MARKETING_URL — origin of the marketing site the blog viewer frames.
 * Must be an `atsready.ai` host: admin's CSP allows `frame-src
 * https://*.atsready.ai` and nothing else. It is unset in every environment
 * today, so the environment-derived default in `resolveMarketingBaseUrl` is
 * what actually runs; setting it overrides that per environment.
 *
 * VITE_ENVIRONMENT — the deploy environment, passed by both workflows. It
 * selects the marketing default and it is named on screen: the Sync-to-Stripe
 * confirmation prints it, because the one thing an operator must know before
 * that write is which Stripe account `STRIPE_SECRET_KEY` points at, and the
 * environment is the only handle admin has on that. It falls back to
 * `development` so the dialog never renders an empty target.
 *
 * Change the fallback here only — do not copy this constant to individual files.
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL || "/api";

export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || "development";

export const MARKETING_BASE_URL = resolveMarketingBaseUrl(
  import.meta.env.VITE_MARKETING_URL,
  import.meta.env.VITE_ENVIRONMENT,
);
